import { Field, Form as FormikForm, Formik } from 'formik';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import React, { useState } from 'react';
import * as Yup from 'yup';
import StaticModal from '../modal/staticModal';
import infoIco from 'assets/images/i-circle.svg';
import Verified from 'assets/images/verified.gif';
import { Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import DashboardHttp from 'pages/profile/services/profile.service';
import { userStore } from 'store/UserStore';
import Loader from '../loader';
import { AxiosResponse } from 'axios';
import './style.css';
import OtpWithTimer from '../otpWithTimer/otpWithTimer';

type Props = {
  isKYCPopupDisplayed: boolean;
  isPanVerficationRequired?: boolean;
  onKYCPopupClose?: () => void;
  closeModal?: () => void;
  hideModal?: () => void;
};

const KYCPopup = ({
  isKYCPopupDisplayed,
  isPanVerficationRequired,
  onKYCPopupClose,
  closeModal,
  hideModal,
}: Props) => {
  const [selectedFile, setSelectedFile] = useState<File>(null);
  const [pan, setPan] = useState('');
  const [aadhaar, setAadhaar] = useState('');
  const [panKyc, setPanKyc] = useState<IPanKycResponse>(null);
  const [isPanChanged, setIsPanChanged] = useState(false);
  const [isPanLoading, setIsPanLoading] = useState(false);
  const [aadhaarKyc, setAadhaarKyc] = useState(null);
  const [isAadhaarChanged, setIsAadhaarChanged] = useState(false);
  const [isAadhaarLoading, setIsAadhaarLoading] = useState(false);
  const [isAadhaarVerified, setisAadhaarVerified] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [panOcrKyc, setPanOcrKyc] = useState<IPanKycResponse>(null);
  const [isPanOcrLoading, setIsPanOcrLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [setCustomer, customer, customerId, user] = userStore((state: any) => [
    state.setCustomer,
    state.customer,
    state.customerId,
    state.user,
  ]);

  const fileChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFile(event.target.files[0]);
    onFileUpload(event);
  };

  const onFileUpload = async (event) => {
    const formData = new FormData();
    setIsPanOcrLoading(true);
    formData.append(
      'myFile',
      event.target.files[0],
      event.target.files[0].name
    );
    try {
      const res: AxiosResponse = await CustomerOnboardingHttp.panOcr(formData);
      if (res.status === 200 && res.data.data) {
        setPanOcrKyc(res.data.data);
      }
      setIsPanOcrLoading(false);
    } catch (e: any) {
      setIsPanOcrLoading(false);
    }
  };

  const updateKyc = async (values, setFieldError, setFieldTouched) => {
    if (!panKyc?.name) {
      setFieldError('pan_number', 'Please verify PAN');
      setFieldTouched('pan_number', true);
      return;
    }
    try {
      setLoading(true);
      let patch_req: any = {
        requiredStatus: 'ENABLED',
        kyc: {},
      };
      if (panKyc?.kycId) {
        patch_req.kyc['pan'] = { kycId: panKyc?.kycId };
      }
      if (panOcrKyc?.kycId) {
        patch_req.kyc['pan_ocr'] = { kycId: panOcrKyc?.kycId };
      }

      const res: any = await CustomerOnboardingHttp.updateCustomer(
        patch_req,
        customerId,
        user?.userId
      );

      if (res.status === 200 && res.data) {
        const userData: any = await DashboardHttp.getProfile(
          customerId,
          user?.userId
        );
        if (userData.status === 200 && userData.data.data) {
          setLoading(false);
          setCustomer(userData.data.data.customer);
          closeModal();
        }
      } else {
        setLoading(false);
        toast.error(res.data.errors[0].title);
      }
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      toast.error('User with same PAN already exists');
      // toast.error(err.data.errors[0].title);
    }
  };
  const onPanChange = async (value, setFieldError, errors) => {
    if (value?.length === 10) verifyPan(value, setFieldError);
  };

  const verifyPan = async (value, setFieldError) => {
    if (value?.length === 10 && /[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(value)) {
      try {
        setIsPanLoading(true);
        const res: AxiosResponse = await CustomerOnboardingHttp.verifyPanNumber(
          {
            pan: value,
            isPanVerficationRequired: isPanVerficationRequired,
          }
        );

        if (res.status === 200 && res.data) {
          setPanKyc(res.data.data);
          setIsPanChanged(false);
          setFieldError('pan_number', '');
        }

        setIsPanLoading(false);
      } catch (error) {
        setIsPanLoading(false);
        setFieldError('pan_number', 'Error while verifying PAN details');
      }
    } else {
      setFieldError('pan_number', 'Invalid PAN');
    }
  };

  const sendOtp = async (
    values,
    setFieldError: (field: string, message: string) => void
  ) => {
    if (!values?.aadhaar_agree) {
      setFieldError('aadhaar_agree', 'Please select consent first');
      return;
    }
    if (
      values?.aadhaar_no?.length === 12 &&
      /[0-9]{12}/.test(values?.aadhaar_no)
    ) {
      try {
        setIsAadhaarLoading(true);
        const res: any = await CustomerOnboardingHttp.sendAadhaarOtp(
          {
            name: customer?.displayName,
            aadhaarNo: values?.aadhaar_no,
            consent: true,
          user_id:user?.userId

          },
          user?.userId
        );

        if (res.status === 200 && res.data) {
          setIsOtpSent(true);
          setIsAadhaarChanged(false);
          setFieldError('aadhaar_no', '');
        }

        setIsAadhaarLoading(false);
      } catch (error) {
        setIsAadhaarLoading(false);
        setFieldError('aadhaar_no', 'Error while verifying Aadhaar details');
      }
    } else {
      setFieldError('aadhaar_no', 'Invalid Aadhaar Number');
    }
  };

  const verifyAadhaarOtp = async (
    value,
    values,
    setFieldError: (field: string, message: string) => void
  ) => {
    if (value?.length === 6 && /[0-9]{6}/.test(value)) {
      try {
        setIsAadhaarLoading(true);
        const res: any =
          await CustomerOnboardingHttp.verifyAadhaarOtp({
            aadhaarNo: values?.aadhaar_no,
            otp: value,
          },
          user?.userId
          );

        if (res.status === 200 && res.data) {
          setIsOtpSent(false);
          setisAadhaarVerified(true);
          setIsAadhaarChanged(false);
        }

        setIsAadhaarLoading(false);
      } catch (error) {
        setisAadhaarVerified(false);
        setIsAadhaarLoading(false);
      }
    } else {
      setFieldError('aadhaar_otp', 'Invalid Aadhaar Number');
    }
  };

  return (
    <>
      {loading && <Loader />}
      <StaticModal
        show={isKYCPopupDisplayed}
        handleClose={onKYCPopupClose}
        title='Update KYC'
        onClose={hideModal}
        // size='lg'
      >
        <Formik
          // innerRef={ref}
          initialValues={{
            pan_number: '',
            // pan_image: '',
            aadhaar_no: '',
            aadhaar_otp: '',
            aadhaar_agree: false,
          }}
          onSubmit={(values, { setFieldError, setFieldTouched }) => {
            updateKyc(values, setFieldError, setFieldTouched);
          }}
          validationSchema={Yup.object().shape({
            pan_number: Yup.string().required('PAN is required'),
            // pan_image: Yup.mixed().required('PAN image is required'),
            aadhaar_agree: Yup.boolean(),
            aadhaar_otp: Yup.string().matches(
              /[0-9]{6}/,
              'Please enter valid OTP'
            ),
          })}
        >
          {({
            values,
            errors,
            touched,
            setFieldError,
            setFieldValue,
            setFieldTouched,
          }) => (
            <FormikForm>
              <Form.Group
                className='mb-3'
                controlId='exampleForm.ControlInput1'
              >
                <Form.Label>Enter your PAN</Form.Label>
                <InputGroup className='mb-3'>
                  <Form.Control
                    placeholder='ABCDE1234F'
                    aria-label='ABCDE1234F'
                    aria-describedby='basic-addon2'
                    name='pan_number'
                    onBlur={(e) => {
                      setFieldTouched('pan_number');
                    }}
                    value={pan}
                    onChange={(e) => {
                      setFieldValue(
                        'pan_number',
                        e.target.value?.toUpperCase()
                      );
                      setPan(e.target.value?.toUpperCase());
                      setIsPanChanged(true);
                      if (e.target.value?.length === 10)
                        verifyPan(e.target.value?.toUpperCase(), setFieldError);
                    }}
                  />
                  {isPanLoading ? (
                    <div className='input-group-text px-2'>
                      <Spinner animation='border' size='sm' />
                    </div>
                  ) : (
                    !errors.pan_number &&
                    panKyc?.name &&
                    !isPanChanged && (
                      <div className='input-group-text px-2'>
                        <img src={Verified} width='22px' height='22px' />
                      </div>
                    )
                  )}
                  {isPanChanged && !isPanLoading && (
                    <button
                      className='btn btn-verify'
                      id='button-pan'
                      type='button'
                      onClick={() => {
                        verifyPan(
                          values.pan_number?.toUpperCase(),
                          setFieldError
                        );
                      }}
                    >
                      Verify
                    </button>
                  )}
                </InputGroup>
                <div className='error'>
                  {errors.pan_number && touched.pan_number && (
                    <small id='my-helper-text'>
                      <img src={infoIco} alt='' />
                      {errors.pan_number}
                    </small>
                  )}
                </div>
                {!errors.pan_number && panKyc?.name && !isPanChanged && (
                  <div className='d-flex justify-content-between mx-1'>
                    <div className='font-weight-bold'>
                      <b>Name on PAN : {panKyc?.name}</b>
                    </div>
                    <img src={Verified} width='22px' height='22px' />
                  </div>
                )}
              </Form.Group>

              {/* <div className='form-group mb-3'>
                <label className='form-label'>PAN Image</label>
                <small className='text-muted'> (Optional)</small>
                <div className='input-group mb-3'>
                  <Field
                    type='file'
                    placeholder=''
                    name='pan_image'
                    className='form-control'
                    value={values.pan_image}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      fileChanged(e);
                      setFieldValue('pan_image', e.target?.value);
                    }}
                  />
                  {isPanOcrLoading ? (
                    <div className='input-group-text px-2'>
                      <Spinner animation='border' size='sm' />
                    </div>
                  ) : (
                    panOcrKyc?.kycId && (
                      <div className='input-group-text px-2'>
                        <img src={Verified} width='20px' height='20px' />
                      </div>
                    )
                  )}
                </div>
                <div className='error'>
                  {errors.pan_image && touched.pan_image && (
                    <small id='my-helper-text'>
                      <img src={infoIco} alt='' />
                      {errors.pan_image}
                    </small>
                  )}
                </div>
              </div> */}
              {/* {!customer?.kyc?.aadhaar?.isVerified && (
                <>
                  <Form.Group className='mb-3' controlId='kycForm.aadharInput'>
                    <Form.Label>Aadhaar Number</Form.Label>

                    <small className='text-muted'> (Optional)</small>
                    <InputGroup className='mb-3'>
                      <Form.Control
                        aria-describedby='basic-addon2'
                        name='aadhaar_no'
                        disabled={isAadhaarVerified}
                        value={aadhaar}
                        onBlur={(e) => {
                          setFieldTouched('aadhaar_no');
                        }}
                        onChange={(e) => {
                          setFieldValue(
                            'aadhaar_no',
                            e.target.value?.toUpperCase()
                          );
                          setAadhaar(e.target.value?.toUpperCase());
                          setIsAadhaarChanged(true);
                        }}
                      />
                      {isAadhaarLoading ? (
                        <div className='input-group-text px-2'>
                          <Spinner animation='border' size='sm' />
                        </div>
                      ) : (
                        !errors.aadhaar_no &&
                        isAadhaarVerified &&
                        !isAadhaarChanged && (
                          <div className='input-group-text px-2'>
                            <img src={Verified} width='22px' height='22px' />
                          </div>
                        )
                      )}
                      {isAadhaarChanged && !isAadhaarLoading && (
                        <button
                          className='btn btn-verify'
                          id='button-addon2'
                          type='button'
                          onClick={(e) => {
                            sendOtp(values, setFieldError);
                          }}
                        >
                          Verify
                        </button>
                      )}
                    </InputGroup>
                    <div className='error'>
                      {errors.aadhaar_no && touched.aadhaar_no && (
                        <small id='my-helper-text'>
                          <img src={infoIco} alt='' />
                          {errors.aadhaar_no}
                        </small>
                      )}
                    </div>
                  </Form.Group>

                  {values?.aadhaar_no?.length > 0 && !isAadhaarVerified && (
                    <>
                      <div className='form-group mb-2'>
                        <label className='form-label'>
                          <Field
                            type='checkbox'
                            placeholder=''
                            name='aadhaar_agree'
                            disabled={isOtpSent}
                            className='mx-1'
                            onChange={(e) => {
                              if (e.target.checked) {
                                setFieldValue(
                                  'aadhaar_agree',
                                  e.target.checked
                                );
                                setFieldError('aadhaar_agree', '');
                              }
                            }}
                          />
                          I Agree to the{' '}
                          <a
                            href='https://ebullion.in/terms-and-conditions/terms.html'
                            target='_blank'
                          >
                            terms and conditions
                          </a>
                        </label>
                      </div>
                      <div className='form-group mb-4'>
                        <div className='error'>
                          {errors.aadhaar_agree && (
                            <small id='my-helper-text'>
                              <img src={infoIco} alt='' />
                              {errors.aadhaar_agree}
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {isOtpSent && (
                    <OtpWithTimer
                      enableResendTimer={true}
                      resendInterval={30}
                      numInputs={6}
                      otpLabel='Please enter OTP'
                      otpChangeHandler={(value) => {
                        setFieldValue('aadhaar_otp', value);
                        setOtpValue(value);

                        if (value?.length === 6) {
                          verifyAadhaarOtp(value, values, setFieldError);
                        }
                      }}
                      isCentered
                      ackMessageType='success'
                      otpValue={otpValue}
                      resendButtonText='Resend OTP'
                      ackMessage='OTP has been sent to your registered mobile number.'
                      resendHandler={() => sendOtp(values, setFieldError)}
                    ></OtpWithTimer>
                  )}
                </>
              )} */}
              <div className='form-group my-3 mt-5'>
                <Button
                  disabled={isAadhaarLoading || isPanLoading}
                  variant='primary'
                  className='w-100'
                  size='lg'
                  type='submit'
                >
                  {!loading ? (
                    'Update'
                  ) : (
                    <div className='spinner-border text-white' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </div>
                  )}
                </Button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </StaticModal>
    </>
  );
};

export default React.memo(KYCPopup);
